// Node type catalog for the Material Flow map. Colors chosen per spec.
export const NODE_TYPES = [
  { key: "raw_material", label: "Components", color: "#1E3A8A", shape: "circle" },
  { key: "raw_material_cat", label: "Raw Material", color: "#4338CA", shape: "circle" },
  { key: "process", label: "Process", color: "#9333EA", shape: "process" },
  { key: "supplier", label: "Supplier", color: "#16A34A" },
  { key: "factory", label: "Factory", color: "#2563EB" },
  { key: "contract_manufacturer", label: "Contract Manufacturer", color: "#0891B2" },
  { key: "co_packer", label: "Co-Packer", color: "#0D9488" },
  { key: "warehouse", label: "Warehouse", color: "#EA580C" },
  { key: "distribution_center", label: "Distribution Center", color: "#D97706" },
  { key: "distributor", label: "Distributor", color: "#CA8A04" },
  { key: "retailer", label: "Retailer", color: "#DB2777" },
  { key: "customer", label: "Customer", color: "#7C3AED" },
  { key: "port", label: "Port", color: "#64748B" },
  { key: "other", label: "Other", color: "#475569" },
];

export const NODE_CFG = Object.fromEntries(NODE_TYPES.map((t) => [t.key, t]));
export const nodeCfg = (kind) => NODE_CFG[kind] || NODE_CFG.other;
